"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseType = void 0;
exports.instanceOfLicenseType = instanceOfLicenseType;
exports.LicenseTypeFromJSON = LicenseTypeFromJSON;
exports.LicenseTypeFromJSONTyped = LicenseTypeFromJSONTyped;
exports.LicenseTypeToJSON = LicenseTypeToJSON;
exports.LicenseTypeToJSONTyped = LicenseTypeToJSONTyped;
/**
 *
 * @export
 */
exports.LicenseType = {
    Rn: 'RN'
};
function instanceOfLicenseType(value) {
    for (const key in exports.LicenseType) {
        if (Object.prototype.hasOwnProperty.call(exports.LicenseType, key)) {
            if (exports.LicenseType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function LicenseTypeFromJSON(json) {
    return LicenseTypeFromJSONTyped(json, false);
}
function LicenseTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function LicenseTypeToJSON(value) {
    return value;
}
function LicenseTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=LicenseType.js.map